var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "accordion__item" },
    [
      _c(
        "div",
        {
          staticClass: "accordion__trigger",
          class: { accordion__trigger_active: _vm.visible },
          on: { click: _vm.open },
        },
        [
          _vm._t("accordion-trigger"),
          _vm._v(" "),
          _c("div", { staticClass: "toggle" }, [
            !_vm.visible && _vm.window.width >= 1240
              ? _c("h5", { staticClass: "coverage-show" }, [
                  _vm._v("\n\t\t\t\tShow Details\n\t\t\t"),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.visible && _vm.window.width < 1240
              ? _c("h5", { staticClass: "coverage-show" }, [
                  _vm._v("\n\t\t\t\tDetails\n\t\t\t"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.visible && _vm.window.width >= 1240
              ? _c("h5", { staticClass: "coverage-hide" }, [
                  _vm._v("\n\t\t\t\tHide\n\t\t\t"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.visible && _vm.window.width < 1240
              ? _c("h5", { staticClass: "coverage-hide" }, [
                  _vm._v("\n\t\t\t\tDetails\n\t\t\t"),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.visible
              ? _c(
                  "svg",
                  {
                    attrs: {
                      width: "24px",
                      height: "24px",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        x: "0",
                        fill: "none",
                        width: "24",
                        height: "24",
                      },
                    }),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        attrs: { d: "M21 13h-8v8h-2v-8H3v-2h8V3h2v8h8v2z" },
                      }),
                    ]),
                  ]
                )
              : _c(
                  "svg",
                  {
                    attrs: {
                      width: "24px",
                      height: "24px",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        x: "0",
                        fill: "none",
                        width: "24",
                        height: "24",
                      },
                    }),
                    _vm._v(" "),
                    _c("g", [_c("path", { attrs: { d: "M3 11h18v2H3z" } })]),
                  ]
                ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "accordion" },
          on: {
            enter: _vm.start,
            "after-enter": _vm.end,
            "before-leave": _vm.start,
            "after-leave": _vm.end,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
              staticClass: "accordion__content",
              class: { open: _vm.visible },
            },
            [_vm._t("accordion-content")],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }